export enum BulkActionProcessingStatus {
    READY = "READY",
    PROCESSING = "PROCESSING",
    WARNING = "WARNING",
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    CANCELLED = "CANCELLED",
}

export enum BulkActionType {
    ADD = "ADD",
    DOWNLOAD = "DOWNLOAD",
}

export interface IBulkActionPayload {
    id: string;
    brandId: string;
    name: string;
    route?: string;
    method?: string;
    data?: any;
    status: BulkActionProcessingStatus;
    error?: string;
    type: BulkActionType;
    resultCustomizer?: (response: any) => any;
}

export interface IJob {
    _id?: string;
    description?: string;
    ref?: string;
    upload_id?: string;
    complete?: boolean;
    upload_url?: string;
    error?: string;
}

export interface IBulkJob {
    _id?: string;
    status?: "pending" | "in-progress" | "complete";
    type?: string;
    jobs?: IJob[];
    combined_job?: IJob;
    brand_id: string;
    modified_on?: Date;
    created_on?: Date;
}

export const getRedirectUrl = (data) => {
    let redirectUrl = data.upload_url;
    const id = data.upload_id || data.id;
    if (data?.upload_url?.includes("exports/appserver")) {
        return redirectUrl;
    }
    if (data?.upload_url?.includes("pdf")) {
        redirectUrl = `//${window.location.host.replace("app.", "wholesale.")}${data.upload_url}`;
    } else if (data?.hasOwnProperty("ats_export_format_id") || redirectUrl?.includes("inventory/export/ats-report")) {
        redirectUrl = `ats/export/${id}`;
    } else if (data?.hasOwnProperty("order_export_format_id") || redirectUrl?.includes("working-order/export")) {
        redirectUrl = `orders/export/${id}`;
    }
    return redirectUrl;
};
